/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * DateIcon component - Icon for date question type
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: colors.NEUTRAL_50)
 * @param className - Additional CSS class name
 */
const DateIcon = ({
  size = 24,
  color = colors.NEUTRAL_50,
  className,
}: QuestionTypeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
    >
      <path
        d='M17 2.5C16.45 2.5 16 2.95 16 3.5V4.5H8V3.5C8 2.95 7.55 2.5 7 2.5C6.45 2.5 6 2.95 6 3.5V4.5H5C3.89 4.5 3.01 5.4 3.01 6.5L3 20.5C3 21.6 3.89 22.5 5 22.5H19C20.1 22.5 21 21.6 21 20.5V6.5C21 5.4 20.1 4.5 19 4.5H18V3.5C18 2.95 17.55 2.5 17 2.5ZM19 20.5H5V10.5H19V20.5ZM11 13.5C11 12.95 11.45 12.5 12 12.5C12.55 12.5 13 12.95 13 13.5C13 14.05 12.55 14.5 12 14.5C11.45 14.5 11 14.05 11 13.5ZM7 13.5C7 12.95 7.45 12.5 8 12.5C8.55 12.5 9 12.95 9 13.5C9 14.05 8.55 14.5 8 14.5C7.45 14.5 7 14.05 7 13.5ZM15 13.5C15 12.95 15.45 12.5 16 12.5C16.55 12.5 17 12.95 17 13.5C17 14.05 16.55 14.5 16 14.5C15.45 14.5 15 14.05 15 13.5ZM11 17.5C11 16.95 11.45 16.5 12 16.5C12.55 16.5 13 16.95 13 17.5C13 18.05 12.55 18.5 12 18.5C11.45 18.5 11 18.05 11 17.5ZM7 17.5C7 16.95 7.45 16.5 8 16.5C8.55 16.5 9 16.95 9 17.5C9 18.05 8.55 18.5 8 18.5C7.45 18.5 7 18.05 7 17.5ZM15 17.5C15 16.95 15.45 16.5 16 16.5C16.55 16.5 17 16.95 17 17.5C17 18.05 16.55 18.5 16 18.5C15.45 18.5 15 18.05 15 17.5Z'
        fill={color}
      />
    </svg>
  )
}

export default DateIcon
